import { render, staticRenderFns } from "./RssFeedWidget.vue?vue&type=template&id=80897382&scoped=true&"
import script from "./RssFeedWidget.vue?vue&type=script&lang=js&"
export * from "./RssFeedWidget.vue?vue&type=script&lang=js&"
import style0 from "./RssFeedWidget.vue?vue&type=style&index=0&id=80897382&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "80897382",
  null
  
)

export default component.exports